import { useEffect, useState } from 'react';
import { history, useModel } from 'umi';

export const SKIP_TOUR_KEY = 'skipTour';
export const setSkipTour = () => localStorage.setItem(SKIP_TOUR_KEY, 'true');
export const getSkipTour = () => localStorage.getItem(SKIP_TOUR_KEY);

type StepConfig = {
  /** 步骤唯一 key */
  stepKey: string;
  /** 引导需要跳转的 url */
  url?: string;
  /**  */
  selector: string;
  title: string;
  description: string;
};

// NOTICE: 步骤 key 必须唯一且顺序与引导一致
export const stepKeys = ['step1', 'step2', 'step3', 'step4', 'step5', 'step6', 'step7', 'step8'];

// NOTICE: title 和 description 都是国际化文案的 text_id
export const stepConfig: Record<string, StepConfig> = {
  [stepKeys[0]]: {
    stepKey: stepKeys[0],
    url: '/account-apply/apply',
    selector: '[data-menu-id$="/account-apply/apply"]',
    title: 'guide_media_account_opening',
    description: 'guide_new_media_account_page_tip',
  },
  [stepKeys[1]]: {
    stepKey: stepKeys[1],
    url: '/account-apply/apply',
    selector: '[class*="bv-Button-container"]',
    title: 'guide_facebook_account_opening_upgrade',
    description: 'guide_vision_line_dedicated_link',
  },
  [stepKeys[2]]: {
    stepKey: stepKeys[2],
    url: '/account-apply/account-opening-record?currentMedia=facebook',
    selector: '[data-menu-id$="/account-apply/account-opening-record"]',
    title: 'guide_account_opening_record_optimization',
    description: 'guide_new_account_record_display',
  },
  [stepKeys[3]]: {
    stepKey: stepKeys[3],
    url: '/account-apply/account-opening-record?currentMedia=facebook',
    selector: '[class*="table-content-wrapper"]',
    title: 'guide_facebook_account_quick_sync',
    description: 'guide_dedicated_link_sync_visionline',
  },
  [stepKeys[4]]: {
    stepKey: stepKeys[4],
    url: '/account-apply/account-opening-record?currentMedia=facebook',
    selector: '[class*="account-apply-btn"]',
    title: 'guide_application_entry_migration',
    description: 'guide_application_entry_moved_here',
  },
  [stepKeys[5]]: {
    stepKey: stepKeys[5],
    url: '/account-apply/account-opening-record?currentMedia=facebook',
    selector: '[class*="apply-details-btn"]',
    title: 'guide_details_display',
    description: 'guide_more_account_info_collected_here',
  },
  [stepKeys[6]]: {
    stepKey: stepKeys[6],
    url: '/account-apply/account-opening-record?currentMedia=google',
    selector: '[class*="google-copy-btn"]',
    title: 'guide_copy_function',
    description: 'guide_click_to_copy_quick_fill',
  },
  [stepKeys[7]]: {
    stepKey: stepKeys[7],
    url: '/account-apply/account-opening-record?currentMedia=google',
    selector: '[class*="google-withdraw-btn"]',
    title: 'guide_withdrawal_function_update',
    description: 'guide_click_withdraw_auto_reject',
  },
  [stepKeys[8]]: {
    stepKey: stepKeys[8],
    url: '/account-apply/account-opening-record?currentMedia=google',
    selector: '[class*="google-account-btn"]',
    title: 'guide_view_closed_accounts',
    description: 'guide_click_to_view_successful_account',
  },
};

export const stepContent: Record<string, React.ReactNode> = {};

export default function useGuideModel() {
  const { initialState } = useModel('@@initialState');
  const [showGuide, setShowGuide] = useState(!getSkipTour());

  const currentUser = initialState?.currentUser;

  const scrollToTop = () => {
    const selectedMenu = document.querySelector('.ant-menu-submenu-selected');
    if (selectedMenu) {
      selectedMenu.classList.add('ant-menu-submenu-open');
      const subMenu = selectedMenu.querySelector('.ant-menu-sub');
      if (subMenu) {
        subMenu.classList.remove('ant-menu-hidden');
      }
      selectedMenu.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      setShowGuide(true);
    }
  };

  const closeGuide = () => setShowGuide(false);

  useEffect(() => {
    const skipTour = getSkipTour();

    // 如果没有看过预览 && 用户登录
    if (!skipTour && currentUser) {
      setShowGuide(true);
      const tempUrl = stepConfig[stepKeys[0]].url;
      if (tempUrl) {
        history.push(tempUrl);
      }
    }
  }, [currentUser]);

  return {
    showGuide,
    scrollToTop,
    closeGuide,
  };
}
